import React from 'react'
import Chaisecontainer from '../../section/Chaisecontainer/Chaisecontainer'

const Chaise = () => {
  return (
   <>
      <Chaisecontainer/>

   </>
  )
}

export default Chaise